import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3 fv-row" }
const _hoisted_4 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "From Date", -1)
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = { class: "col-md-3 fv-row" }
const _hoisted_8 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "To Date", -1)
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = { class: "col-md-1 fv-row" }
const _hoisted_12 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-9" }, null, -1)
const _hoisted_14 = { class: "position-relative" }
const _hoisted_15 = { class: "col-md-3 fv-row" }
const _hoisted_16 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_17 = { align: "center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_19 = { class: "fs-2 fw-bolder" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Search Result(s)", -1)
const _hoisted_21 = {
  class: "ag-theme-alpine",
  style: {"height":"500px","width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading_init]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control form-control-solid",
                  format: "DD/MM/yyyy",
                  name: "from_date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.from_date = $event))
                }, null, 512), [
                  [_vModelText, _ctx.from_date]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control form-control-solid",
                  format: "DD/MM/yyyy",
                  name: "to_date",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.to_date = $event))
                }, null, 512), [
                  [_vModelText, _ctx.to_date]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary er fs-6 px-8 py-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.recruitmentshistory();})
                }, " View ")
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.recruitment_length), 1)
              ]),
              _hoisted_20
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_ag_grid_vue, {
            style: {"width":"100%","height":"100%"},
            columnDefs: _ctx.columnDefs,
            defaultColDef: _ctx.defaultColDef,
            rowModelType: "infinite",
            pagination: true,
            paginationPageSize: _ctx.itemsPerPage,
            cacheBlockSize: 100,
            onGridReady: _ctx.onGridReady
          }, null, 8, ["columnDefs", "defaultColDef", "paginationPageSize", "onGridReady"])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading_init]
    ])
  ], 64))
}